import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { shorts } from '@/mocks/home';

export default function Shorts() {
  return (
    <section id="shorts" className="border-y border-background-200/70 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          kicker="精彩短视频"
          title="直播高光，随手就能刷"
          desc="主播直播中的精彩瞬间被实时剪辑成短视频，没赶上的场次也能接着看。"
          action={
            <a
              href="#live"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-play-list-2-line" />
              更多短视频
            </a>
          }
        />

        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {shorts.map((item, index) => (
            <Reveal key={item.id} delay={(index % 6) * 60}>
              <article className="group relative aspect-[3/4] cursor-pointer overflow-hidden rounded-xl border border-background-200">
                <img
                  src={item.cover}
                  alt={`${item.title} 短视频封面`}
                  title={`糖豆视频 ${item.tag} 短视频`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent" />

                <span className="absolute right-2 top-2 rounded bg-foreground-950/60 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur-sm">
                  {item.duration}
                </span>

                <span className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-background-50/25 text-background-50 backdrop-blur-sm transition-transform duration-300 group-hover:scale-110">
                  <i className="ri-play-fill text-2xl" />
                </span>

                <div className="absolute inset-x-0 bottom-0 p-3">
                  <h3 className="line-clamp-2 font-heading text-sm font-bold leading-snug text-background-50">
                    {item.title}
                  </h3>
                  <div className="mt-2 flex items-center justify-between text-[11px] text-background-100/80">
                    <span className="truncate">{item.tag}</span>
                    <span className="flex shrink-0 items-center gap-1">
                      <i className="ri-play-circle-line" />
                      {item.views}
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}